export default __webpack_public_path__ + "static/map/img/presentation-header.50fd0ea.png";